module.exports = __webpack_public_path__ + "img/one.812d0dea.jpg";